import axios from 'axios'
import { DataFile } from 'src/shared/types/data-file-interface'

export const WL_BRAND_SETTINGS_API_URL = '/api/brand-settings'

export interface WhiteLabelBrandSettingsColors {
  oldBrandPrimary: string
  oldTextPrimary: string
  oldBackgroundPrimary: string
  oldBackgroundHeader: string
}

export interface WhiteLabelBrandSettingsInterface {
  id: number | null
  name: string
  logo:
    | (DataFile & {
        name: string | null
        thumbnail: string | null
      })
    | null
  favicon:
    | (DataFile & {
        name: string | null
        thumbnail: string | null
      })
    | null
  dashboardHostname: string
  colors: WhiteLabelBrandSettingsColors | null
}

export const defaultWhiteLabelBrandSettings: WhiteLabelBrandSettingsInterface =
  {
    id: null,
    name: 'Systeme.io',
    dashboardHostname: 'systeme.io',
    colors: {
      oldBrandPrimary: '#00A0FF',
      oldTextPrimary: '#142D63',
      oldBackgroundPrimary: '#F1F4F8',
      oldBackgroundHeader: '#FFFFFF',
    },
    logo: {
      id: 0,
      name: 'Systeme.io Logo',
      filename: 'systemeio-logo.svg',
      path: 'https://d1yei2z3i6k35z.cloudfront.net/161/68c03b5dc30e4_systemelogo.svg',
      thumbnail: null,
    },
    favicon: {
      id: 0,
      name: 'Systeme.io Favicon',
      filename: 'systemeio-favicon.svg',
      path: 'https://d2543nuuc0wvdg.cloudfront.net/images/logo_small.svg',
      thumbnail: null,
    },
  }

export const getWhiteLabelBrandSettings = async () => {
  const response = await axios.get<WhiteLabelBrandSettingsInterface>(
    WL_BRAND_SETTINGS_API_URL,
  )
  return response.data
}
